module.exports = __webpack_public_path__ + "img/reward_100.8c2a8ba1.png";